<div class="agenda-container">
  <!-- Tutorial Overlay -->
  <ngx-tutorial-overlay></ngx-tutorial-overlay>
  
  <!-- Loading Spinner - only show when loading for the first time -->
  <div *ngIf="carregando && !dadosCarregados" class="loading-container">
    <div [nbSpinner]="carregando" nbSpinnerSize="giant" nbSpinnerStatus="primary" [nbSpinnerMessage]="msgLoading">
      <p>Carregando compromissos...</p>
    </div>
  </div>

  <!-- Calendar View -->
  <div *ngIf="(!carregando || dadosCarregados) && mostrarCalendario" class="calendar-view">
    <div class="calendar-section">
      <div class="calendar-header">
        <button class="nav-button" (click)="mesAnterior()">
          <nb-icon icon="chevron-left-outline"></nb-icon>
        </button>
        <div class="header-center">
          <h3>{{ nomeDoMes }} {{ anoAtual }}</h3>
          <button class="refresh-button" (click)="forcarRecarregamento()" [disabled]="carregando" title="Atualizar compromissos">
            <nb-icon icon="refresh-outline" [class.spinning]="carregando"></nb-icon>
          </button>
        </div>
        <button class="nav-button" (click)="proximoMes()">
          <nb-icon icon="chevron-right-outline"></nb-icon>
        </button>
      </div>
      
      <div class="calendar-grid">
        <div class="day-header">Dom</div>
        <div class="day-header">Seg</div>
        <div class="day-header">Ter</div>
        <div class="day-header">Qua</div>
        <div class="day-header">Qui</div>
        <div class="day-header">Sex</div>
        <div class="day-header">Sáb</div>
        
        <div 
          *ngFor="let dia of diasDoMes" 
          class="calendar-day"
          [class.other-month]="!dia.mesAtual"
          [class.has-appointment]="dia.temCompromisso"
          [class.clickable]="dia.mesAtual && dia.temCompromisso"
          (click)="selecionarDia(dia)">
          <span class="day-number">{{ dia.numero }}</span>
          <span *ngIf="dia.quantidadeCompromissos > 0" class="appointment-count client-appointments">{{ dia.quantidadeCompromissos }}</span>
          <span *ngIf="dia.quantidadeCompromissosCustomizados > 0" class="appointment-count custom-appointments">{{ dia.quantidadeCompromissosCustomizados }}</span>
          <!-- Add appointment overlay -->
          <div *ngIf="dia.mesAtual" class="add-appointment-overlay" (click)="adicionarCompromisso(dia, $event)">
            <span class="add-icon">+</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Today Section -->
    <div *ngIf="temCompromissosHoje || temCompromissosCustomizadosHoje" class="today-section">
      <h4>Hoje</h4>
      <div class="today-appointments">
        <!-- Client appointments -->
        <div *ngFor="let compromisso of compromissosHoje" 
             class="appointment-item clickable client-appointment" 
             [ngClass]="obterClasseCompromisso(compromisso)"
             (click)="abrirCompromissoEspecifico(compromisso)">
          <div class="appointment-client">{{ compromisso.nomeCliente }}</div>
          <div class="appointment-time">{{ compromisso.dtRetorno | date:'HH:mm' }}</div>
          <div class="appointment-type">Cliente</div>
        </div>
        
        <!-- Custom appointments -->
        <div *ngFor="let compromisso of compromissosCustomizadosHoje" 
             class="appointment-item clickable custom-appointment"
             (click)="selecionarCompromissoCustomizadoHoje(compromisso)">
          <div class="appointment-client">{{ compromisso.titulo }}</div>
          <div class="appointment-time">{{ compromisso.data_compromisso | date:'HH:mm' }}</div>
          <div class="appointment-type">Pessoal</div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Appointment Details View -->
  <div *ngIf="(!carregando || dadosCarregados) && !mostrarCalendario && diaSelecionado" class="appointment-details">
    <div class="details-header">
      <button class="back-button" (click)="voltarParaCalendario()">
        <nb-icon icon="arrow-back-outline"></nb-icon>
      </button>
      <h4>{{ diaSelecionado.data | date:'dd/MM/yyyy' }}</h4>
    </div>
    
    <div class="details-content">
      <div class="appointments-list">
        <!-- Regular client appointments -->
        <div *ngFor="let compromisso of compromissosNoDiaSelecionado" 
             class="appointment-item clickable client-appointment" 
             [ngClass]="obterClasseCompromisso(compromisso)"
             (click)="selecionarCompromisso(compromisso)">
          <div class="appointment-client">{{ compromisso.nomeCliente }}</div>
          <div class="appointment-time">{{ compromisso.dtRetorno | date:'HH:mm' }}</div>
          <div class="appointment-type">Cliente</div>
        </div>
        
        <!-- Custom appointments -->
        <div *ngFor="let compromisso of compromissosCustomizadosNoDiaSelecionado" 
             class="appointment-item clickable custom-appointment"
             (click)="selecionarCompromissoCustomizado(compromisso)">
          <div class="appointment-client">{{ compromisso.titulo }}</div>
          <div class="appointment-time">{{ compromisso.data_compromisso | date:'HH:mm' }}</div>
          <div class="appointment-type">Pessoal</div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Feedback Details View -->
  <div *ngIf="(!carregando || dadosCarregados) && !mostrarCalendario && compromissoSelecionado" class="feedback-details">
    <div class="details-header">
      <button class="back-button" (click)="voltarParaLista()">
        <nb-icon icon="arrow-back-outline"></nb-icon>
      </button>
      <h4>Detalhes do Compromisso</h4>
    </div>
    
    <div class="details-content">
      <div class="detail-item">
        <label>Cliente:</label>
        <span>{{ compromissoSelecionado.nomeCliente }}</span>
      </div>
      
      <div class="detail-item">
        <label>Data/Hora:</label>
        <span>{{ compromissoSelecionado.dtRetorno | date:'dd/MM/yyyy HH:mm' }}</span>
      </div>
      
      <div class="detail-item">
        <label>Feedback:</label>
        <div class="feedback-content">{{ compromissoSelecionado.feedback }}</div>
      </div>
    </div>
  </div>
  
  <!-- Custom Appointment Details View -->
  <div *ngIf="(!carregando || dadosCarregados) && !mostrarCalendario && compromissoCustomizadoSelecionado" class="custom-appointment-details">
    <div class="details-header">
      <button class="back-button" (click)="voltarParaLista()">
        <nb-icon icon="arrow-back-outline"></nb-icon>
      </button>
      <h4>Detalhes do Compromisso Pessoal</h4>
    </div>
    
    <div class="details-content">
      <div class="detail-item">
        <label>Título:</label>
        <span>{{ compromissoCustomizadoSelecionado.titulo }}</span>
      </div>
      
      <div class="detail-item">
        <label>Data/Hora:</label>
        <span>{{ compromissoCustomizadoSelecionado.data_compromisso | date:'dd/MM/yyyy HH:mm' }}</span>
      </div>
      
      <div class="detail-item">
        <label>Descrição:</label>
        <div class="feedback-content">{{ compromissoCustomizadoSelecionado.descricao }}</div>
      </div>
      
      <div class="action-buttons">
        <button class="edit-button" (click)="editarCompromissoCustomizadoSelecionado()">
          <nb-icon icon="edit-outline"></nb-icon>
          Editar
        </button>
        <button class="remove-button" (click)="removerCompromissoCustomizadoSelecionado()">
          <nb-icon icon="trash-2-outline"></nb-icon>
          Remover
        </button>
      </div>
    </div>
  </div>
</div> 